import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import Flex from '@atlaskit/primitives/components/flex';
import { xcss } from '@atlaskit/primitives/xcss';
import Lozenge from '@atlaskit/lozenge/lozenge';

import { AILabsLozenge } from '@atlassian/ai-components/ai-labs-lozenge';

const titleSpacingStyles = xcss({
	marginRight: 'space.075',
});

export const ItemTitleWithLozenge = ({
	children,
	lozenge,
	useLabsLozenge,
}: {
	children: React.ReactNode;
	lozenge?: React.ReactNode;
	useLabsLozenge?: boolean;
}): React.JSX.Element => (
	<Flex alignItems="center" justifyContent="space-between">
		<Box xcss={titleSpacingStyles}>{children}</Box>
		{useLabsLozenge ? <AILabsLozenge /> : <Lozenge appearance="discovery">{lozenge}</Lozenge>}
	</Flex>
);
